<template>
	<div class="right_content">
		<div class="flex_center" :style="{ justifyContent: tablist.length == 1 ? 'flex-end' : '' }">
			<div
				class="right-tab flex_center"
				:class="active == item.type ? 'active' : 'no_active'"
				:style="{ marginLeft: index == 1 ? '6px' : '0' }"
				v-for="(item, index) in tablist"
				:key="index"
				@click="changeTab(item.type)"
			>
				<img :src="active == item.type ? item.showIcon : item.icon" />
				<p style="margin-left: 3px">{{ item.name }}</p>
			</div>
		</div>
		<div class="content_box">
			<div
				class="flex_center"
				v-if="active == 'user' && showEmpty"
				style="width: 100%; height: 100%"
			>
				<div class="flex_center" style="flex-direction: column">
					<img style="width: 40px; height: 40px" src="../assets/none_thing/no_user.png" alt="" />
					<p class="none_thing">暂无用户信息</p>
				</div>
			</div>
			<!-- 历史 -->
			<div class="right_info" v-if="active == 'user' && !showEmpty">
				<div class="userinfo">
					<p class="common_title" style="margin-top: 37px">用户账号:</p>
					<p class="common_text">{{ userInfo.username }}</p>
					<p>
						<span class="common_title">昵称：</span
						><span class="common_text">{{ userInfo.nickname }}</span>
					</p>
					<p style="margin-top: 30px">
						<span class="common_title">认证状态：</span
						><span class="common_text">{{ userInfo.authenticationStatus }}</span>
					</p>
					<p>
						<span class="common_title">真实姓名：</span
						><span class="common_text">{{ userInfo.realName }}</span>
					</p>
					<p>
						<span class="common_title">地区：</span
						><span class="common_text">{{ userInfo.authenticationAddress }}</span>
					</p>
					<p>
						<span class="common_title">手机号码：</span
						><span class="common_text" v-if="userInfo.mobile">+{{ userInfo.areaCode }} {{ userInfo.mobile }}</span>
					</p>
					<p>
						<span class="common_title">身份证号码：</span
						><span class="common_text">{{ userInfo.idCard }}</span>
					</p>
					<p style="margin-top: 30px">
						<span class="common_title">会员状态：</span
						><span class="common_text">{{ userInfo.memberStatus=='user'?'一般':userInfo.memberStatus=='vip'?'vip':userInfo.memberStatus}}</span>
					</p>
					<p>
						<span class="common_title">会员开始时间：</span
						><span class="common_text" v-if="userInfo.memberStartTime">{{
							dayjs(userInfo.memberStartTime).format("YYYY-MM-DD")
						}}</span>
					</p>
					<p>
						<span class="common_title">会员结束时间：</span
						><span class="common_text" v-if="userInfo.memberEndTime">{{
							dayjs(userInfo.memberEndTime).format("YYYY-MM-DD")
						}}</span>
					</p>
					<p>
						<span class="common_title">注册时间:</span
						><span class="common_text" v-if="userInfo.registerTime">{{
							dayjs(userInfo.registerTime).format("YYYY-MM-DD")
						}}</span>
					</p>
					<p style="margin-top: 30px">
						<span class="common_title">未发货：</span
						><span class="common_text">{{ userInfo.orderDetailList.length }}</span>
					</p>
					<div v-for="(item, index) in userInfo.orderDetailList" :key="index">
						<p>
							<span class="common_title">订单号：</span
							><span class="common_text">{{ item.orderNum }}</span>
						</p>
						<p>
							<span class="common_title">下单时间：</span
							><span class="common_text">{{ dayjs(item.createTime).format("YYYY-MM-DD") }}</span>
						</p>
					</div>
					<div style="padding-bottom: 40px">
						<p class="common_title" style="margin-top: 30px">中选记录:</p>
						<div v-for="(item, index) in userInfo.selectedRecord" :key="index">
							<p class="common_text">{{ item.applyName }}</p>
							<p class="common_text" v-if="item.selectedTime">
								{{
									dayjs(item.selectedTime).format("YYYY-MM-DD")
									
								}}
							</p>
							<p>
								<span class="common_title">活动类型：</span
								><span class="common_text">{{ item.applyType }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 快捷回复 -->
			<div v-if="active == 'replay' && replayList.length > 0" class="flex_center group_list">
				<div v-for="(item, index) in replayList" :key="index">
					<div class="pro_common flex_common group_Name" @click="changeReplay(index)">
						<img
							class="group_img"
							src="../assets/down_icon.png"
							alt=""
							v-if="index == replyIndex"
						/>
						<img class="group_img" src="../assets/right_icon.png" alt="" v-else />
						<p style="margin-left: 5px;flex:1">
							{{ item.groupName }}
						</p>
						<div style="margin-left: 5px;margin-right:5px">({{ item.replyList.length }})</div>
					</div>
					<!-- 问题答案 -->
					<div v-if="index == replyIndex">
						<div
							v-for="(it, inx) in item.replyList"
							:key="inx"
							@click="copyReplay(it.content)"
							style="margin-top: 10px"
						>
							<div class="pro_title pro_common">
								Q:{{ it.title }}
							</div>
							<div  class="pro_content pro_common">
								<div>A:</div>
								<div v-html="it.content"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="flex_center"
				v-if="active == 'replay' && replayList.length == 0"
				style="width: 100%; height: 100%"
			>
				<div class="flex_center" style="flex-direction: column">
					<img style="width: 40px; height: 40px" src="../assets/none_thing/no_reply.png" alt="" />
					<p class="none_thing">暂无问答</p>
				</div>
			</div>
		</div>
		<div></div>
	</div>
</template>

<script setup>
import { ref, onMounted,onActivated } from "vue";
import { get } from "../utils/request";
import dayjs from "dayjs";
const replyIndex = ref(-1);
const props = defineProps({
	showReply: {
		type: Boolean,
		default: false,
	},
	showEmpty: {
		type: Boolean,
		default: true,
	},
});
const emit = defineEmits();
const active = ref("user");
const replayList = ref([]);
const userInfo = ref({
	username: "",
	nickname: "",
	authenticationStatus: "",
	realName: "",
	authenticationAddress: "",
	mobile: "",
	idCard: "",
	memberStatus: "",
	memberStartTime: "",
	memberEndTime: "",
	registerTime: "",
	orderDetailList: [],
	selectedRecord: [],
});
const tablist = ref([]);
onActivated(()=>{
	getHotReply()
	
})
onMounted(() => {
	getHotReply();
	if (!props.showReply) {
		tablist.value = [
			{
				name: "用户信息",
				icon: require("../assets/user_info.png"),
				showIcon: require("../assets/user_infos.png"),
				type: "user",
			},
		];
	} else {
		tablist.value = [
			{
				name: "用户信息",
				icon: require("../assets/user_info.png"),
				showIcon: require("../assets/user_infos.png"),
				type: "user",
			},
			{
				name: "快捷回复",
				icon: require("../assets/replays.png"),
				showIcon: require("../assets/replay.png"),
				type: "replay",
			},
		];
	}
});
const changeReplay = (index) => {
	if (replyIndex.value == index) {
		replyIndex.value = -1;
	} else {
		replyIndex.value = index;
	}
};
//获取快捷回复
const getHotReply = () => {
	get("/api-cms/reply/group").then((res) => {
		if (res.code == 1) {
			replayList.value = res.result;
		}
	});
};
const changeTab = (type) => {
	active.value = type;
};
//复制回复
const copyReplay = (reply) => {
	emit("copyReplay", reply);
};
const getUserInfo = (id) => {
	get(`/api-cms/reception/user/${id}`, {}, false).then((res) => {
		if (res.code == 1) {
			const data = res.result;
			data.selectedRecord.forEach((item) => {
				switch (item.applyType) {
					case 1:
						item.applyType = "一般活动";
						break;
					case 2:
						item.applyType = "演唱会";
						break;
					case 3:
						item.applyType = "后台活动";
						break;
					case 4:
						item.applyType = "见面会";
						break;
				}
			});

			switch (data.authenticationStatus) {
				case 0:
					data.authenticationStatus = "未认证";
					break;
				case 1:
					data.authenticationStatus = "已认证";
					break;
				case 2:
					data.authenticationStatus = "待审核";
					break;
				case 3:
					data.authenticationStatus = "审核不通过";
					break;
			}
			userInfo.value = data;
		}
	});
};

defineExpose({ getUserInfo });
</script>

<style scoped lang="less">
.right_content {
	width: 260px;
	height: 100%;
	overflow: hidden;
	.content_box {
		width: 100%;
		background: #f7f7f7;
		height: 100%;
		margin-top: 6px;
		overflow: auto;
	}
	.right_info {
		overflow: auto;
		padding: 0 20px;
		padding-bottom: 40px;
		.common_title {
			font-size: 14px;
			color: #999999;
		}
		.common_text {
			font-size: 14px;
			color: #333333;
		}
		.userinfo {
			max-width: 200px;
			cursor: pointer;
		}
	}
	.right-tab {
		cursor: pointer;
		width: 50%;
		height: 26px;

		border-radius: 4px;

		img {
			width: 16px;
			height: 16px;
		}
	}
}
.none_thing {
	font-size: 14px;
	color: #999999;
	line-height: 22px;
}
.no_active {
	opacity: 0.5;
	background: #c194ff;
	color: #ffffff;
}
.active {
	background: #f5eeff;
	color: #a15bff;
}
.group_list {
	flex-direction: column;
	font-size: 14px;
	color: #606266;
	padding-bottom: 40px;
	.group_img {
		width: 16px;
		height: 16px;
		margin-left: 10px;
	}
	.group_Name {
		padding: 10px 0;
		margin-top: 20px;
	}
	.pro_common {
		width: 220px;
		font-size: 14px;
		line-height: 22px;
		background: #ffffff;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		cursor: pointer;
		box-sizing: border-box;
		:deep(h1) {
			line-height: 32px;
		}
	}
	.pro_title {
		color: #606266;
		padding: 5px 10px;
	}
	.pro_content {
		color: #999999;
		padding: 5px 10px;
		margin-top: 5px;
		word-break: break-all;
		display: flex
	}
}
</style>
